// src/screens/inquiry/InquiryDetailScreen.js
import React from 'react';
import InquiryDetail from '../../inquiry/InquiryDetail';

/**
 * 문의 상세 스크린 컴포넌트
 */
const InquiryDetailScreen = () => {
  return <InquiryDetail />;
};

export default InquiryDetailScreen;